import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, FILE_BASE } from "../config";
import "./CSS/CartInfo.css";

const CartInfo = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {
      const response = await axios.get(`${API_BASE}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCartItems(response.data);
      console.log(response.data, "cart");
    } catch (error) {
      console.error("Cart fetch error:", error);
    }
  };

  const removeFromCart = async (productId) => {
    try {
      await axios.delete(`${API_BASE}/cart/remove/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCartItems((prev) => prev.filter((x) => x.productId !== productId));
    } catch (error) {
      console.error("Remove cart error:", error);
    }
  };

  const updateQuantity = async (productId, newQty) => {
    try {
      if (newQty <= 0) {
        removeFromCart(productId);
        return;
      }

      await axios.put(
        `${API_BASE}/cart/update-quantity`,
        {
          productId: productId,
          quantity: newQty,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setCartItems((prev) =>
        prev.map((item) =>
          item.productId === productId
            ? {
                ...item,
                quantity: newQty,
                subtotal: item.price * newQty,
              }
            : item,
        ),
      );
    } catch (error) {
      console.error("Update quantity error:", error);
    }
  };

  const total = cartItems.reduce((acc, item) => acc + item.subtotal, 0);

  return (
    <div className="cart-container">
      <div className="cart-left">
        <div className="cart-header">
          <p>Product</p>
          <p>Price</p>
          <p>Quantity</p>
          <p>Subtotal</p>
        </div>
        {cartItems.map((item) => (
          <div className="cart-item" key={item.productId}>
            <div className="cart-product">
              <img src={item.image} alt={item.productName} />
              <span>{item.productName}</span>
            </div>
            <p>Rs. {item.price}</p>
            <div className="cart-qty-box">
              <button
                className="qty-btnn"
                onClick={() =>
                  updateQuantity(item.productId, item.quantity - 1)
                }
              >
                -
              </button>
              <span className="qty-value">{item.quantity}</span>
              <button
                className="qty-btnn"
                onClick={() =>
                  updateQuantity(item.productId, item.quantity + 1)
                }
              >
                +
              </button>
            </div>
            <p>Rs. {item.subtotal}</p>
            <button
              className="delete-btn"
              onClick={() => removeFromCart(item.productId)}
            >
              ❌
            </button>
          </div>
        ))}
      </div>
      <div className="cart-right">
        <h2>Cart Totals</h2>
        <div className="totals">
          <p>Subtotal</p>
          <span>Rs. {total}</span>
        </div>
        <div className="totals">
          <p>Total</p>
          <span className="total-price">Rs. {total}</span>
        </div>
        <button className="checkout-btn" onClick={() => navigate("/checkout")}>
          Checkout
        </button>
      </div>
    </div>
  );
};

export default CartInfo;
